"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _reactAriaModal = _interopRequireDefault(require("react-aria-modal"));

var _dialogCard = _interopRequireDefault(require("../dialog-card"));

var _excluded = ["children", "className", "css", "includeDefaultStyles", "open", "scrollDisabled", "type", "underlayClass", "underlayColor"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_PREFIX = 'vds-dialog';
var CSS_STATE = 'vds-state';
var Dialog = (0, _react.forwardRef)(function (_ref, ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      css = _ref.css,
      includeDefaultStyles = _ref.includeDefaultStyles,
      open = _ref.open,
      scrollDisabled = _ref.scrollDisabled,
      type = _ref.type,
      underlayClass = _ref.underlayClass,
      underlayColor = _ref.underlayColor,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  (0, _react.useEffect)(function () {
    var html = document.documentElement;

    if (open) {
      return html.classList.add('vds-dialog-no-scroll');
    }

    return html.classList.remove('vds-dialog-no-scroll');
  }, [open]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, open ? /*#__PURE__*/_react.default.createElement(_reactAriaModal.default, _extends({
    css: css,
    dialogClass: (0, _classnames2.default)(CSS_PREFIX, (_classnames = {}, _defineProperty(_classnames, "".concat(CSS_STATE, "--show"), true), _defineProperty(_classnames, "".concat(CSS_STATE, "--").concat(type), Boolean(type)), _classnames), className),
    includeDefaultStyles: includeDefaultStyles,
    ref: ref,
    scrollDisabled: scrollDisabled,
    underlayClass: underlayClass,
    underlayColor: underlayColor
  }, remainingProps), /*#__PURE__*/_react.default.createElement(_dialogCard.default, null, children)) : undefined);
});
Dialog.propTypes = {
  /**
  * @ignore
  */
  children: _propTypes.node,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * @ignore
   */
  css: _propTypes.func,

  /**
   * Include default styles
   */
  includeDefaultStyles: _propTypes.bool,

  /**
   * Show dialog
   */
  open: _propTypes.bool,

  /**
   * Scroll disabled
   */
  scrollDisabled: _propTypes.bool,

  /**
   * Dialog Type
   */
  type: (0, _propTypes.oneOf)(['error', 'success', 'warning']),

  /**
   * Dialog underlay class
   */
  underlayClass: _propTypes.string,

  /**
   * Dialog underlay color
   */
  underlayColor: _propTypes.bool
};
Dialog.defaultProps = {
  includeDefaultStyles: false,
  scrollDisabled: false,
  underlayClass: "".concat(CSS_PREFIX, "-curtain ").concat(CSS_STATE, "--show"),
  underlayColor: false
};
Dialog.displayName = 'Dialog';
var _default = Dialog;
exports.default = _default;